/**
 * @generated SignedSource<<3de8df13edfd4d26dd16f8145dc89891>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SimilarRecentlySoldItemsPriceRange = "BETWEEN_HIGH_AVG_AND_MAX" | "BETWEEN_LOW_AVG_AND_MEDIAN" | "BETWEEN_MEDIAN_AND_HIGH_AVG" | "BETWEEN_MIN_AND_LOW_AVG" | "HIGHER_RANGE" | "LOWER_RANGE" | "MEDIAN" | "NEAR_MEDIAN" | "NEAR_MEDIAN_HIGH" | "NEAR_MEDIAN_LOW" | "OTHER" | "OUT_OF_RANGE_HIGH" | "OUT_OF_RANGE_LOW" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedRecentSalesCopy_item$data = {
  readonly classification: {
    readonly categories: ReadonlyArray<{
      readonly category: {
        readonly browseUrl: string | null;
        readonly name: string | null;
      } | null;
      readonly precedence: number | null;
    } | null> | null;
  } | null;
  readonly creators: ReadonlyArray<{
    readonly attribution: string | null;
    readonly creator: {
      readonly displayName: string | null;
      readonly name: string | null;
    } | null;
  } | null> | null;
  readonly iconicDesign: {
    readonly browsePageLinkData: {
      readonly isLinkable: boolean | null;
      readonly path: string | null;
    };
    readonly displayName: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly similarRecentlySoldItemsPrices: {
    readonly priceRange: SimilarRecentlySoldItemsPriceRange | null;
  } | null;
  readonly " $fragmentType": "PdpSharedRecentSalesCopy_item";
};
export type PdpSharedRecentSalesCopy_item$key = {
  readonly " $data"?: PdpSharedRecentSalesCopy_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedRecentSalesCopy_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "currency"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedRecentSalesCopy_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "currency",
          "variableName": "currency"
        }
      ],
      "concreteType": "SimilarRecentlySoldItemsPrices",
      "kind": "LinkedField",
      "name": "similarRecentlySoldItemsPrices",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "priceRange",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IconicDesign",
      "kind": "LinkedField",
      "name": "iconicDesign",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "browsePageLinkData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isLinkable",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemCreator",
      "kind": "LinkedField",
      "name": "creators",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "attribution",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Creator",
          "kind": "LinkedField",
          "name": "creator",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemClassification",
      "kind": "LinkedField",
      "name": "classification",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemCategory",
          "kind": "LinkedField",
          "name": "categories",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "precedence",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Category",
              "kind": "LinkedField",
              "name": "category",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "browseUrl",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "e56cc74859f7fc37c186d22bd4d93736";

export default node;
